const convertUnicodeToEmoji = function(unicode) {
  if (unicode.indexOf("-") > -1) {
    const parts = [];
    const s = unicode.split("-");
    for (let i = 0; i < s.length; i++) {
      let part = parseInt(s[i], 16);
      if (part >= 65536 && part <= 1114111) {
        let hi = Math.floor((part - 65536) / 1024) + 55296;
        let lo = (part - 65536) % 1024 + 56320;
        part = String.fromCharCode(hi) + String.fromCharCode(lo);
      } else {
        part = String.fromCharCode(part);
      }
      parts.push(part);
    }
    return parts.join("");
  } else {
    const s = parseInt(unicode, 16);
    if (s >= 65536 && s <= 1114111) {
      const hi = Math.floor((s - 65536) / 1024) + 55296;
      const lo = (s - 65536) % 1024 + 56320;
      return String.fromCharCode(hi) + String.fromCharCode(lo);
    } else {
      return String.fromCharCode(s);
    }
  }
};
var convertUnicodeToEmoji_default = convertUnicodeToEmoji;
export {
  convertUnicodeToEmoji_default as default
};
//# sourceMappingURL=convertUnicodeToEmoji.js.map
